import React from '../services/React';
import UI from '../services/UI';

class TextInput extends React.Component {
  constructor(props) {
    super(props);

    this.updateValue = this.updateValue.bind(this);
  }

  updateValue() {
    const { value } = this.props;
    this.textInput.setValue(value);
  }

  componentDidMount() {
    this.updateValue();
  }

  componentDidUpdate() {
    this.updateValue();
  }

  render() {
    const { value, ...otherProps } = this.props;
    return (
      <UI.textInput
        ref={textInput => this.textInput = textInput}
        {...otherProps}
      />
    );
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/commons/components/TextInput.jsx